export const apiErrors = {
  error401: 'Невірний логін або пароль. Будь ласка, спробуйте ще раз.',
  error403: 'Доступ заборонено. Будь ласка, перевірте свої права.',
  error404:
    'Вибачте, не вдалося знайти запитану інформацію. Схоже, що дані, які ви шукаєте, недоступні. Будь ласка, перевірте ваш запит і спробуйте ще раз',
  error500: 'Внутрішня помилка сервера. Будь ласка, спробуйте знову пізніше.',
  noResponseError: 'Немає відповіді від сервера. Будь ласка, спробуйте знову пізніше.',
  defaultError: 'Виникла помилка під час обробки запиту. Будь ласка, спробуйте пізніше',
};
